import { Flex, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';
export const Card = (props)=>{
    const { size , variant , ...flexProps } = props;
    const styles = useMultiStyleConfig('Card', {
        size,
        variant
    });
    return /*#__PURE__*/ React.createElement(Flex, {
        __css: styles.container,
        ...flexProps
    });
};

//# sourceMappingURL=card.js.map